import {daUtils} from '../_utils';
import {
    IApiResponse,
    IDatasourceRequest,
    IItemIdRequest, IItemIdsRequest,
    IItemSIdRequest,
    IUser,
    IMuiDataRequest, IUserItemIdRequest,
} from "./types";
import {API_PAF_BASE_URI} from "./index";
import {merge} from "lodash";

const API_USER_GET =`${API_PAF_BASE_URI}/users/filter/`;
const API_USER_GET_BY_ID =`${API_PAF_BASE_URI}/users/{user_id}/`;
const API_USER_GET_BY_SID =`${API_PAF_BASE_URI}/users/{user_sid}/`;
const API_USER_ADD =`${API_PAF_BASE_URI}/users/`;
const API_USER_UPD =`${API_PAF_BASE_URI}/users/{user_id}/`;
const API_USER_DEL =`${API_PAF_BASE_URI}/users/delete/`;
const API_USER_CUSTOMER_GET =`${API_PAF_BASE_URI}/users/{user_id}/companies/`;
const API_USER_CUSTOMER_ADD =`${API_PAF_BASE_URI}/users/companies/`;
const API_USER_CUSTOMER_DEL =`${API_PAF_BASE_URI}/users/companies/delete/`;
const API_USER_LISTADMIN_GET =`${API_PAF_BASE_URI}/users/{user_id}/listadmins/`;
const API_USER_LISTADMIN_ADD =`${API_PAF_BASE_URI}/users/listadmins/`;
const API_USER_LISTADMIN_DEL =`${API_PAF_BASE_URI}/users/listadmins/delete/`;
const API_USER_GROUP_GET =`${API_PAF_BASE_URI}/users/{user_id}/groups/`;
const API_USER_GROUP_ADD =`${API_PAF_BASE_URI}/users/groups/`;
const API_USER_GROUP_DEL =`${API_PAF_BASE_URI}/users/groups/delete/`;

const get = async (
    options: IMuiDataRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_USER_GET;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        return resp;
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_id = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: "GET",
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_USER_GET_BY_ID.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const get_by_sid = async (
    options: IItemSIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'GET',
            cache: "no-cache",
        };
        const sid = options.sid;
        const url = API_USER_GET_BY_SID.replace('{user_sid}', sid);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}


const add = async (
    options: IUser,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_USER_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const update = async (
    options: IUser,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'PUT',
            body: JSON.stringify(options)
        };
        const id = options.id!.toString();
        const url = API_USER_UPD.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_USER_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const customers_get = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: "GET",
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_USER_CUSTOMER_GET.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const customers_add = async (
    options: IUserItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_USER_CUSTOMER_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const customers_remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_USER_CUSTOMER_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const listadmins_get = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: "GET",
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_USER_LISTADMIN_GET.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const listadmins_add = async (
    options: IUserItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_USER_LISTADMIN_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const listadmins_remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_USER_LISTADMIN_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const groups_get = async (
    options: IItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: "GET",
            cache: "no-cache",
        };
        const id = options.id.toString();
        const url = API_USER_GROUP_GET.replace('{user_id}', id);
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const groups_add = async (
    options: IUserItemIdRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'POST',
            body: JSON.stringify(options)
        };
        const url = API_USER_GROUP_ADD;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

const groups_remove = async (
    options: IItemIdsRequest,
    auth_token: string | undefined = undefined) => {
    try {
        const requestOptions: RequestInit = {
            method: 'DELETE',
            body: JSON.stringify(options)
        };
        const url = API_USER_GROUP_DEL;
        const resp: IApiResponse = await daUtils.daFetch(url, requestOptions, auth_token);

        if (resp) {
            return resp;
        }
    }
    catch (e: any) {
        alert(e.message);
    }
}

// export interface ApiRequestProps {
//     requestOptions: RequestInit,
// }

// const get_requestOptions = (options: unknown, auth_token: string | undefined = undefined): RequestInit => {
//     let requestHeaders: Headers = new Headers({
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//     });
//     if (auth_token !== undefined) {
//         requestHeaders.append('Authorization', `Bearer ${auth_token}`);
//     }
//
//     const requestOptions: RequestInit = {
//          mode: 'cors',
//          headers: requestHeaders,
//          method: 'POST',
//          body: JSON.stringify(options)
//     };
//
//     return requestOptions;
// }

// const exec_api_request =
//     async (url: RequestInfo | string, requestOptions: RequestInit): Promise<ApiResponseType | undefined> => {
//     try {
//         const resp: ApiResponseType = await daUtils.doFetch(url, requestOptions);
//         if (resp) {
//             return resp;
//         }
//
//         // return await daUtils.daFetch(url, requestOptions);
//     }
//     catch (e: any) {
// //         alert(e.message);
//     }
// }

export const userApi = {
    get,
    get_by_id,
    get_by_sid,
    add,
    update,
    remove,
    customers_get,
    customers_add,
    customers_remove,
    listadmins_get,
    listadmins_add,
    listadmins_remove,
    groups_get,
    groups_add,
    groups_remove,
};